import { TChipSize, IChipStructure } from './HBChip.types';
import spacing from '../../styles/spacing';

/**
 * Structure configuration for different chip sizes
 */
export const CHIP_STRUCTURE: Record<TChipSize, IChipStructure> = {
    small: {
        height: spacing[24],
        textType: 'body14',
        iconLineHeight: spacing[12],
        padding: spacing[8],
        iconGap: spacing[4]
    },
    medium: {
        height: spacing[32],
        textType: 'body16',
        iconLineHeight: spacing[16],
        padding: spacing[12],
        iconGap: spacing[6]
    },
    large: {
        height: spacing[40],
        textType: 'body18',
        iconLineHeight: spacing[16],
        padding: spacing[16],
        iconGap: spacing[8]
    }
};
